import React from "react";

const videoPlayer = ({color = 'black', width = '24px', height = '24px'}) => {
  return (
    <div style={{width:width,height:height}}>
        <svg viewBox="0 0 509 476" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M230.085 367.5H38.5001C10.5001 367.5 8.58538 350 8.58545 339C8.58545 244.5 8.58545 50.9 8.58545 32.5C8.58545 17.5 21 9 32.0855 9C173.919 9 461.985 9 479.585 9C497.185 9 500.085 21.5 500.085 29.5C500.085 123 500.085 315.8 500.085 339C500.085 356 483.5 367.5 471.585 367.5H282.085H279.585M230.085 367.5V427.5C230.085 430.261 227.847 432.5 225.085 432.5H103.585M230.085 367.5H279.585M103.585 432.5V462C103.585 464.761 105.824 467 108.585 467H402.085C404.847 467 407.085 464.761 407.085 462V437.5C407.085 434.739 404.847 432.5 402.085 432.5H279.585M103.585 432.5H279.585M279.585 432.5V367.5M203.848 107.187L352.275 182.528C355.929 184.383 355.923 189.605 352.265 191.451L203.838 266.341C200.512 268.019 196.585 265.602 196.585 261.877V111.645C196.585 107.915 200.522 105.498 203.848 107.187Z" stroke={color} stroke-width="17"/>
        </svg>
    </div>
  );
};

export default videoPlayer;
